import * as React from 'react'
import { useState, useRef, ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../ui/button'
import ChangeAvatar from '../../profile/popups/avatarPopup'

const AvatarUploader: React.FunctionComponent = () => {
    const [t] = useTranslation()
    const fileInput = useRef(null)
    const [file, setFile] = useState(null)

    const selectPhotoClick = (): void => {
        fileInput.current.click()
    }

    const onFileInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
        event.preventDefault()
        const reader = new FileReader()

        reader.onload = (e) => {
            setFile(e.target.result)
        }
        reader.readAsDataURL(event.target.files[0])
    }

    return (
        <>
            <Button type="button" onClick={selectPhotoClick} label="Change">
                {t('Change')}
            </Button>
            <input type="file" accept="image/jpeg" className="fileInput" onChange={onFileInputChange} ref={fileInput} />
            {file && <ChangeAvatar file={file} onClose={() => setFile(null)} />}
        </>
    )
}

export default AvatarUploader
